export const environment = {
    authServiceUrl: 'https://dev.flippyboards.com',
};
